import axios from "axios";

const sendEmail = () => axios.post("/account/personal/reset_password");

export default sendEmail;
